import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import * as api from './api';
import * as types from './types';

export const clearOwner = createAction(types.CLEAR_OWNER);
export const clearStatuses = createAction(types.CLEAR_STATUSES);
export const filtersInitialized = createAction(types.INITIALIZE_FILTERS);
export const resetFilters = createAction(types.RESET_FILTERS);
export const selectOwner = createAction(types.SELECT_OWNER);
export const togglePerformance = createAction(types.TOGGLE_PERFORMANCE);
export const toggleStatus = createAction(types.TOGGLE_STATUS);
export const updateOwnerFilter = createAction(types.UPDATE_OWNER);
export const updateFiltersFromLS = createAction(types.UPDATE_FILTERS_FROM_LS);

export const getOrgUsers = createApiAction(
  types.GET_ORG_USERS,
  api.getOrgUsers,
  { meta: { skipErrorPage: true } },
);

export const getTeamList = createApiAction(
  types.TEAMLIST_GET,
  api.getTeams,
  { meta: { skipErrorPage: true } },
);
